import Icon from '../components/Icon.vue'

Icon.register({
  tractor: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M528 336c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zM528 448c13.2 0 24-10.8 24-24s-10.8-24-24-24-24 10.8-24 24 10.8 24 24 24zM608 160c17.7 0 32 14.3 32 32v50.8c0 8.5-3.4 16.6-9.4 22.6l-50.8 50.8c-15.7-7.6-33.2-12.2-51.8-12.2-39.1 0-73.5 19-95.5 48h-80.5v6c0 12.2-9.8 22-22 22h-7.2c-3 9.9-6.9 19.5-11.9 28.7l5.1 5.1c8.6 8.6 8.6 22.5 0 31.1l-31.1 31.1c-8.6 8.6-22.5 8.6-31.1 0l-5.1-5.1c-9.3 5-18.8 9-28.7 11.9v7.1c0 12.2-9.9 22-22 22h-44c-12.2 0-22-9.8-22-22v-7.2c-9.9-2.9-19.5-6.9-28.7-11.9l-5.1 5.1c-8.6 8.6-22.5 8.6-31.1 0l-31.1-31.1c-8.6-8.6-8.6-22.5 0-31.1l5.1-5.1c-5-9.3-9-18.8-11.9-28.7h-7.1c-12.2 0-22-9.9-22-22v-44c0-12.2 9.8-22 22-22h7.2c2.9-9.9 6.9-19.5 11.9-28.7l-5.1-5.1c-8.6-8.6-8.6-22.5 0-31.1l31.1-31.1c7.9-7.9 20.3-8.2 28.9-1.5v-146.5c0-26.5 21.5-48 48-48h133.4 0c17.5 0 37.2 13.1 44.1 29.1l56.1 130.9h102.3v-40.2c0-30 10.6-58.9 29.5-81.7 6.4-7.7 18-8.2 24.7-0.8l21.6 24.2c4.9 5.4 5.7 13.7 1.3 19.5-8.5 11.1-13.2 24.7-13.2 38.8v40.2h64zM176 416c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zM198 160h110l-41.2-96h-106.9v96h38z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tractor.js
// module id = 2022
// module chunks = 0